import API from "./baseApi";

const getServices = (payload) => {
  return API.post("/services/get", payload);
};

const createServices = (payload) => {
  return API.post("/services", payload);
};

const getServiceById = (payload) => {
  return API.get(`/services/${payload}`);
};

const updateServices = (id, payload) => {
  return API.patch(`/services/${id}`, payload);
};

const createPrgramServiceMapping = (payload) => {
  return API.post(`/services/createPrgramServiceMapping`, payload);
};

const deletePrgramServiceMapping = (payload) => {
  return API.post(`/services/deletePrgramServiceMapping`, payload);
};

const uploadServiceImage = (payload) => {
  return API.post("/services/serviceImageUpdate", payload);
};

const subServiceImgUpload = (id, payload) => {
  return API.put(`/services/uploadImage/subServiceMappping/${id}`, payload);
};
const updateServiceType = ( payload) => {
  return API.post(`/services/service/updateType`, payload);
};
export default {
  getServices,
  createServices,
  updateServices,
  getServiceById,
  createPrgramServiceMapping,
  deletePrgramServiceMapping,
  uploadServiceImage,
  subServiceImgUpload,
  updateServiceType
};
